import Vue from 'vue';
// @ts-ignore
import Results from './Results/Results.vue';

export class SearchResultPage {
  constructor(searchResults) {
    const query = searchResults.dataset.query || '';
    const url = searchResults.dataset.url || '';
    const core = searchResults.dataset.core || '';
    const noResults = searchResults.dataset.noResults || '';
    const resultsForTerm = searchResults.dataset.resultsForTerm || '';
    const searchLabel = searchResults.dataset.searchLabel || '';
    new Vue({
      el: '.js-resultpage',
      template: '<Results :query="query" :url="url" :core="core" :noResults="noResults" :resultsForTerm="resultsForTerm" :searchLabel="searchLabel"/>',
      data: {query, url, core, noResults, resultsForTerm, searchLabel},
      components: {Results},
    });
  }
}
